import { constructs } from "../api/contructs";
import { CreateGenericReducer } from "./CreateGenericReducer";

export const ModelsReducer = CreateGenericReducer(constructs["model"]);
